export const config = {
  API_URL:
    process.env.REACT_APP_API_URL || "https://riskreport.almata.co.jp:3400/api",
};

export const paymentConfig = {
  stripe: {
    publishableKey: process.env.REACT_APP_STRIPE_PUBLISH_KEY,
  },
};
